<div class="venue-card" [routerLink]="[link]">
	<div class="venue-card__icon">
		<i class="tagmeicon tagmeicon-{{ icon }}"></i>
	</div>
	<div class="venue-card__boxText">
		<p class="venue-card__text"><ng-content></ng-content></p>
	</div>
</div>
